module.exports = __webpack_public_path__ + "static/BPLogo-9e9b281a3aedd0e1cc948e5dcc043a8e.png";